import { useTranslation } from "react-i18next";
import { PatternSale } from "../types/backend-generated/PatternSale";
import { formatCents } from "../utils/currencyFormat";
import { formatLocaleDate } from "../utils/dateFormat";
import styles from "./SalesOverview.module.css";

function Sales({ sales }: { sales: PatternSale[] }) {
  const { t } = useTranslation();

  return (
    <div className={styles.salesTable}>
      <div className={styles.tableHeader}>
        <div className={styles.headerItem}><div className={styles.date}>{t("sales.date")}</div></div>
        <div className={styles.headerItem}> <div className={styles.pattern}>{t("sales.pattern")}</div></div>
        <div className={styles.headerItem}><div className={styles.yarn}>{t("sales.yarn")}</div></div>
        <div className={styles.headerItem}><div className={styles.total}>{t("sales.total")}</div></div>
      </div>
      {sales.map((sale: PatternSale) => {
        
        return (
          <div className={styles.tableRow} key={sale.created}>
            <div className={styles.columnItem}>
             
             <div className={styles.date}> {formatLocaleDate(sale.created)} </div>
              
            </div>
            <div className={styles.columnItem}>
              {" "}
              <div className={styles.pattern}>{formatCents(sale.patternDesignerAmountExclVat)} </div>
            </div>
            <div className={styles.columnItem}>
              {" "}
              <div className={styles.yarn}>{`${formatCents(sale.yarnCutAmountExclVat)} (${sale.yarn_cut_percent ? sale.yarn_cut_percent : 0 }%)`}</div>
            </div>
            <div className={styles.columnItem}>
              {" "}
              <div className={styles.total}>{formatCents(sale.totalAmountExclVat ? sale.totalAmountExclVat : 0 )}{" "}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Sales;
